
export const PAGE_TITLE_LABEL_KEY = 'CURRENT_OFFERINGS';

export const PRINT_ICON_LABEL = 'Print';
export const EMAIL_ICON_LABEL = 'Email';
export const NOTIFICTION_ICON_LABEL = 'Notification';

export const WEEKLY_OFFEERINGS_TITLE_LABEL_KEY = 'WEEKLY_OFFERINGS';
